module.exports = __webpack_public_path__ + "25c1919e10360dd8c4165d67b4a167a2.wasm";